<script setup lang="ts">
    import { inject } from 'vue';
    import ImagePreview from '@shared/components/Images/ImagePreview.vue';
    import EventEditorDetailsNav from '@views/Event/EventEditor/Details/EventEditorDetailsNav.vue';
    import { type Event } from '@views/Event/EventTypes';
    import { eventKey, saveEventPropertyKey, canEditKey } from '@views/Event/EventEditor/event-editor-keys';

    const props = defineProps<{
        eventId: string;
    }>();

    const event = inject(eventKey)!;
    const canEdit = inject(canEditKey)!;
    const saveEventProperty = inject(saveEventPropertyKey)!;

    function onHeroImageUrlChange(newValue: string) {
        saveEventProperty('HeroImageUrl', newValue, $Resources.GenericHeroImageLabel);
    }
</script>

<template>
    <div v-if="event" class="max-900">
        <h2 class="h3 m-0-t m-xs-b">{{ $Resources.GenericHeroImageLabel }}</h2>
        <p>{{ $Resources.EventHeroImageInfoText }}</p>
        <ImagePreview :imageSrc="event.HeroImageUrl" :isDisabled="!canEdit" @update:imageSrc="onHeroImageUrlChange"></ImagePreview>

        <EventEditorDetailsNav v-if="event" :eventId="props.eventId" />
    </div>
</template>
